import CreateNewOrderIcon from '../../../assets/images/New Order.svg'
import CreateNewRequestIcon from '../../../assets/images/New Asset Request.svg'
import { Breadcrumb, Card, Search, ModalPopup, PrimaryButton, ReactSelectBox, Label } from '../../../CommonComponents'
import MyOrderGrid from './MyOrderGrid'
import excel from '../../../assets/images/Excel.svg'
import { DateRangePicker } from 'rsuite';
import OrderTypePopup from '../Home/OrdertypePopup'
import './CustomerMyOrder.scss'
import { useSelector } from 'react-redux';
import moment from 'moment';
import LoadingWrapper from "../../../CommonComponents/LoadingWrapper"
import permissions, { isAuthorized } from 'client/utils/Permissions'

const CustomerMyOrder = (props: any) => {
    const { 
        isMyOrdersGridCountsLoading,    
        searchByOptions,
        globalSearchBy,
        onGlobalSearchByChange ,
        onSearchOrder,
        alreadyHasGridFilterValues
    } = props
    const costCenterList = props?.costCenterList;
    const updatedByList = props?.updatedByList;
    const assignedToList = props?.assignedToList;
    const requestedByList = props?.requestedByList;
    const regionList = props?.regionList;
    const orderStatusList = props?.orderStatusList;
    const orderRequestList = props?.orderRequestList;
    const buyerNameList = props?.buyerNameList;
    const fleetItemStatusList = props?.fleetItemStatusList
    const {
        cartNav
    }: any = useSelector(
        (state: any) => ({
            cartNav: state.MyOrder.setCartNav
        })
    )
    const modalPopupTitle = () => {
        if (activeNavigation == 'Asset') {
            return ("REQUEST TYPE");
        } else {
            return ("ORDER TYPE");
        }
    }

    const activeNavigation = useSelector((state: any) => state.nav.nav)
    const popupName = () => {
        if (activeNavigation == 'Asset') {
            // return <RequestTypePopup />
        }
        else {
            return <OrderTypePopup setShowPopup={props.setModalDisplay} />
        }
    }

    return <>
        <div className='CustomerMyOrder mt-1'>
            <div className='breadcrumb-toolbar mb-2'>
                <button disabled = {!(activeNavigation === 'Asset' ? isAuthorized(permissions.CreateUpdateTransfers) || isAuthorized(permissions.ViewTransfers) : isAuthorized(permissions.RequisitionsCreateUpdate) || isAuthorized(permissions.RequisitionsView))} 
                    className='create-new-order-btn mb-3 mb-md-0 me-2' 
                    title={activeNavigation === 'Asset' ? 'Manage Existing Assets' : 'Create New Requisition'}  data-attribute="CustomerMyOrder_Default_Button">
                    <a onClick={props.CreateNewRequisitionHandleClick}>
                        <img src={activeNavigation === 'Asset' ? CreateNewRequestIcon : CreateNewOrderIcon} alt='btn-icon' />
                        <span>{activeNavigation === 'Asset' ? 'Manage Existing Assets' : 'Create New Requisition'}</span>
                    </a>
                </button>
                <div className='order-1'><Breadcrumb items={props.breadcrumlist} maxDisplayedItems='5'  data-attribute="CustomerMyOrder_Default_Breadcrumb" /></div>
            </div>
            {
                <Card data-attribute="CustomerMyOrder_Default_Card">
                    <div className='create-new-order-container assetContainer'>
                        <div className='create-new-order-block mb-md-3'>
                            {
                                props.orderList.map((item: any, index: number) => {
                                    const activeMenu = () => {
                                        if (props.activeMenu === item.displayText) {
                                            return ("active");
                                        } else {
                                            return ('');
                                        }
                                    }
                                    const unSubmittedVal = () => {
                                        if ('Unsubmitted' === item.displayText) {
                                            return ("active");
                                        } else {
                                            return ('');
                                        }
                                    }
                                    return (
                                        <div key={index} data-attribute={`CustomerMyOrder_${(item?.displayText || item?.text || index).toString().replace(/[^a-zA-Z0-9]+/g, '_')}_Item`} onClick={() => props.handleClick(item.displayText)} className={cartNav == '' ? (`create-new-order ${item.icontype} ${activeMenu()}`) : (`create-new-order ${'draft'} ${unSubmittedVal()}`)}>
                                            <div className='pull-left'>
                                                <p className='order-type'>{item.text}</p>
                                                <LoadingWrapper isLoading={isMyOrdersGridCountsLoading} data-attribute="CustomerMyOrder_Default_LoadingWrapper">
                                                <a className='order-link' href='/' onClick={(e: any) => e.preventDefault()}>{item.link}</a>
                                                </LoadingWrapper>
                                                <span className='subText'>{item.subText ? `(${item.subText})` : ''}</span>
                                            </div>
                                            <div className='pull-right'>
                                                <div className='order-icon'>
                                                    {
                                                        props.activeMenu === item.displayText ?
                                                            <img src={item.activeIcon} alt='order-icons' /> :
                                                            <img src={item.icon} alt='order-icons' />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                )
                            }
                        </div>
                        <div className='grid-block pt-2'>
                            <div className='mb-1 top-section'>
                                <p className='mt-1'>{activeNavigation == 'Asset' ? 'MY ASSETS' : 'ORDERS'}</p>
                                <div className='clearfix mt-2 mb-3'>
                                        <div className='pull-left searchblock global-search'>
                                            <Label className='mb-0' data-attribute="CustomerMyOrder_Default_Label">Search By</Label>
                                            <div className='search-dropdown-block'>
                                                <ReactSelectBox
                                                    name='globalSearch'
                                                    options={searchByOptions}
                                                    value={globalSearchBy}
                                                    onChange={onGlobalSearchByChange}
                                                    className='global-search-drop-down'
                                                 data-attribute="CustomerMyOrder_globalSearch_SearchSelectBox" />
                                                <Search
                                                    placeholder={`Search By ${globalSearchBy?.label}`}
                                                    className='searchTextbox'
                                                    onSearch={(e?: any) => onSearchOrder(e, true)}
                                                    onBlur={(e?: any) => onSearchOrder(e, false)}
                                                    onChange={(e?: any) => onSearchOrder(e, false)}
                                                    value={props?.myOrdersearchBoxValue}
                                                 data-attribute="CustomerMyOrder_Default_Searchbox" />
                                            </div>
                                        </div>
                                    <div className='pull-right datepickerControl mb-2 mb-sm-0 mt-sm-0 mt-2'>
                                        <DateRangePicker
                                            placement='bottomEnd'
                                            format="MM/dd/yyyy"
                                            character=' - '
                                            onChange={props.onDateChange}
                                            placeholder='MM/DD/YYYY - MM/DD/YYYY'
                                            preventOverflow={true} value={props.dateRange}
                                            defaultCalendarValue={[new Date(moment().subtract(1, 'months').startOf('month').toDate()), new Date(moment().startOf('month').toDate())]}
                                         data-attribute="CustomerMyOrder_Default_DateRangePicker" />
                                        <PrimaryButton text='Clear Filters' disabled={alreadyHasGridFilterValues()} onClick={props.handleFilterClear} className='filter-btn'  data-attribute="CustomerMyOrder_Default_Button_2" />
                                        <div className='excel-section hide'>
                                            <img src={excel} alt='excel' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {props.showGrid &&
                                <MyOrderGrid
                                    branchList={props?.branchList}
                                    data={props.data}
                                    activeMenu={props.activeMenu}
                                    assetGridFilters={props?.assetGridFilters}
                                    requestGridFilters={props?.requestGridFilters}
                                    myOrdersearchBoxValue={props?.myOrdersearchBoxValue}
                                    dateRange={props?.dateRange}
                                    serverTotal={props?.serverTotal}
                                    costCenterList = {costCenterList}
                                    updatedByList = {updatedByList}
                                    assignedToList = {assignedToList}
                                    requestedByList = {requestedByList}
                                    regionList = {regionList}
                                    orderStatusList = {orderStatusList}
                                    orderRequestList = {orderRequestList}
                                    fleetItemStatusList = {fleetItemStatusList}
                                    buyerNameList = {buyerNameList}
                                    globalSearchBy={globalSearchBy?.value}
                                />
                            }
                        </div>
                    </div>
                </Card>
            }
        </div>
        {
            props.showMyOrderTypePopup
                ? <ModalPopup
                    ShowModalPopupFooter={false}
                    ModalPopupTitle={modalPopupTitle()}
                    ModalPopupType="small"
                    closeModalPopup={props.hidePopup}
                    ModalPopupName=""
                 data-attribute="CustomerMyOrder_Default_ModalPopup">
                    {
                        popupName()
                    }
                </ModalPopup>
                : null
        }
    </>
}

export default CustomerMyOrder;